import { render, staticRenderFns } from "./yatri-festival.vue?vue&type=template&id=2d51ebb0"
import script from "./yatri-festival.vue?vue&type=script&lang=js"
export * from "./yatri-festival.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports